import React from "react";
import SellerSidebar from "./SellerSidebar";

const SellerLayout = ({ children }) => {
    return (
        <div style={styles.container}>
            <SellerSidebar />
            <div style={styles.contentWrapper}>
                <div style={styles.contentPadding}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default SellerLayout;

const styles = {
    container: {
        display: 'flex',
        minHeight: '100vh',
    },
    contentWrapper: {
        marginLeft: 250,
    },
    contentPadding: {
        padding: 30,
    },
};
